<div class="full-page-modal-container">
  <div class="modal-content-wrapper">
    <div class="config-panel" [style.height.px]="configPanelHeight">
      <div class="config-panel-left">
        <div class="panel-header panel-header-left">
          <app-fade-text
            class="left-panel-header"
            [text]="'Mobile Inspection App Preview'"
            [customStyles]="{
              fontSize: '20px',
              lineHeight: '28px',
              fontWeight: '500',
              letterSpacing: '0',
              whiteSpace: 'nowrap'
            }"></app-fade-text>
          <div class="panel-header-actions">
            <span *ngIf="!isInitialLoading" class="menu-trigger">
              <ng-container *ngFor="let word of getMenuTriggerWords('Add field to form'); let last = last">
                <span
                  [matMenuTriggerFor]="addFieldMenu"
                  (menuOpened)="isAddFieldMenuOpen = true"
                  (menuClosed)="isAddFieldMenuOpen = false">
                  {{ word }}
                  <span *ngIf="!last"></span>
                </span>
              </ng-container>
              <span
                [matMenuTriggerFor]="addFieldMenu"
                (menuOpened)="isAddFieldMenuOpen = true"
                (menuClosed)="isAddFieldMenuOpen = false">
                <app-icon
                  class="caret-icon"
                  [iconColor]="EColorPalette.cGray11"
                  [iconHeight]="16"
                  [iconWidth]="16"
                  [svg]="isAddFieldMenuOpen ? EIcon.CARET_UP : EIcon.CARET_DOWN"></app-icon>
              </span>
            </span>
          </div>
        </div>

        <div *ngIf="isInitialLoading; else leftContent" class="left-loading-container">
          <mat-spinner diameter="40"></mat-spinner>
        </div>

        <ng-template #leftContent>
          <div class="panel-content preview-content">
            <div class="mobile-preview-panel mobile-preview-panel-cut simple-preview">
              <div class="phone-frame" [style.height.px]="workflowPreviewHeight">
                <div class="svg-mobile-frame-container" style="position: absolute; inset: 0">
                  <svg viewBox="0 0 390 740" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M311.953 0C332.916 0 351.822 4.92752 365.495 15.9936C379.163 27.0596 387.59 44.2658 387.59 68.8215V234.22H388.013C388.557 234.22 389.058 234.426 389.421 234.765C389.776 235.099 390 235.563 390 236.075V322.139C390 322.651 389.776 323.114 389.421 323.449C389.058 323.783 388.557 323.993 388.013 323.993H387.59V669.481C387.59 697.318 377.742 714.948 363.615 725.619C349.488 736.29 331.093 740 313.988 740H78.6195C57.656 740 38.7502 735.073 25.0823 724.006C11.4093 712.944 2.98273 695.737 2.98273 671.182V323.53H2.5641C2.01381 323.53 1.51753 323.323 1.15967 322.985C0.796745 322.651 0.570551 322.186 0.570551 321.674V269.015C0.570551 268.503 0.796745 268.035 1.15967 267.702C1.51753 267.366 2.01381 267.157 2.5641 267.157H2.98273V252.39H2.5641C2.01381 252.39 1.51753 252.184 1.15967 251.845C0.796745 251.511 0.570551 251.048 0.570551 250.535V197.877C0.570551 197.365 0.796745 196.901 1.15967 196.562C1.51753 196.228 2.01381 196.022 2.5641 196.022H2.98273V170.737H1.98849C1.43988 170.737 0.943603 170.528 0.584055 170.192C0.22113 169.858 0 169.394 0 168.879V144.347C0 143.835 0.22113 143.372 0.584055 143.037C0.943603 142.698 1.43988 142.492 1.98849 142.492H2.98273V70.5222C2.98273 42.6863 12.8306 25.0565 26.9577 14.3841C41.083 3.71335 59.4841 0 76.5837 0H311.953ZM76.2883 16.1258C65.1137 16.1258 49.3054 17.9998 37.4774 26.9336C25.798 35.7588 19.8781 50.45 19.8781 70.6104V671.27C19.8781 689.597 25.3186 703.296 36.0477 711.988C48.3719 721.958 65.8395 724.054 78.3241 724.054H313.693C324.868 724.054 340.676 722.18 352.502 713.243C364.188 704.421 370.103 689.726 370.103 669.569V68.9097C370.103 50.5791 364.663 36.88 353.934 28.1919C341.613 18.2187 324.142 16.1258 311.657 16.1258H76.2883Z"
                      fill="#100F0D" />
                  </svg>
                </div>

                <div class="mobile-device">
                  <div class="mobile-system-top">
                    <div class="mobile-notch"></div>
                    <div class="mobile-status-bar">
                      <span class="time">{{ currentTime | date : 'hh:mm' }}</span>
                      <div class="display-flex grid-gap-8">
                        <app-icon [svg]="EIcon.SIGNAL" [iconWidth]="18" [iconHeight]="12"></app-icon>
                        <app-icon [svg]="EIcon.WIFI" [iconWidth]="17" [iconHeight]="12"></app-icon>
                        <app-icon [svg]="EIcon.BATTERY" [iconWidth]="28" [iconHeight]="12"></app-icon>
                      </div>
                    </div>
                  </div>

                  <div class="mobile-content-stack">
                    <div class="mobile-sheet sheet-back">
                      <div class="sheet-back-content">
                        <div class="mobile-app-header">
                          <span>Create PropUp Ticket</span>
                          <button class="close-icon">×</button>
                        </div>
                        <div class="mobile-content no-scrollbar">
                          <app-cost-file-ticket-parts-setup-placeholder
                            [showRate]="false"
                            [captureMode]="
                              useFileIcon ? ImageCaptureMode.AnyFile : ImageCaptureMode.PhotoAndGallery
                            "></app-cost-file-ticket-parts-setup-placeholder>
                        </div>
                      </div>
                    </div>
                    <div class="mobile-sheet sheet-shadow"></div>

                    <div class="mobile-sheet sheet-front">
                      <div class="mobile-content-container">
                        <div class="mobile-app-header">
                          <span>Create PropUp Ticket</span>
                          <button class="close-icon">×</button>
                        </div>
                        <div class="mobile-content no-scrollbar">
                          <div class="mobile-form">
                            <app-cost-file-ticket-parts-setup-option
                              *ngFor="let type of mobileFieldTypes"
                              [optionType]="type"
                              [selected]="selectedMobileFieldType === type"
                              (optionSelected)="
                                toggleSelectedFieldType($event)
                              "></app-cost-file-ticket-parts-setup-option>
                            <div
                              class="w-100 display-flex flex-column justify-content-space-between grid-gap-8"
                              [attr.guid]="'guid-comment'">
                              <span class="area-container-label">
                                Add photos
                                <!-- <span class="required">*</span> -->
                              </span>
                              <div
                                class="area-container display-flex align-items-center justify-content-center overflow-hidden">
                                <app-icon
                                  [iconHeight]="48"
                                  [iconWidth]="48"
                                  [svg]="useFileIcon ? EIcon.CLOUD_UPLOAD : EIcon.PHOTO_CAMERA"
                                  [iconColor]="EColorPalette.cOrange2"></app-icon>
                              </div>
                            </div>
                            <div
                              class="w-100 display-flex flex-column justify-content-space-between grid-gap-8"
                              [attr.guid]="'guid-comment'">
                              <span class="area-container-label">
                                Add comment
                                <!-- <span class="required">*</span> -->
                              </span>
                              <div class="area-container overflow-hidden">
                                <span>Type your comment here...</span>
                              </div>
                            </div>
                            <div class="mobile-done-button">Done</div>
                          </div>
                        </div>

                        <div class="home-indicator"></div>
                        <div class="home-indicator-gradient"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="showMobilePreview" class="preview-blur-overlay" (click)="toggleMobilePreview()">
                <button class="preview-close-button">Close full-screen mode</button>
              </div>
            </div>

            <mat-icon
              class="open-in-new-icon"
              [matTooltip]="showMobilePreview ? 'Hide mobile preview' : 'Show mobile preview'"
              [matTooltipShowDelay]="500"
              (click)="toggleMobilePreview()">
              open_in_new
            </mat-icon>
          </div>

          <div class="workflow-setup">
            <div class="workflow-setup-header">
              <app-fade-text
                class="workflow-setup-title"
                [text]="'Workflow Setup'"
                [customStyles]="{
                  fontSize: '16px',
                  fontWeight: '700',
                  color: EColorPalette.cGray4,
                  whiteSpace: 'nowrap'
                }"></app-fade-text>
              <span class="menu-trigger">
                <ng-container *ngFor="let word of getMenuTriggerWords('Add field to workflow'); let last = last">
                  <span
                    [matMenuTriggerFor]="addWorkflowMenu"
                    (menuOpened)="isAddWorkflowMenuOpen = true"
                    (menuClosed)="isAddWorkflowMenuOpen = false">
                    {{ word }}
                    <span *ngIf="!last"></span>
                  </span>
                </ng-container>
                <span
                  [matMenuTriggerFor]="addWorkflowMenu"
                  (menuOpened)="isAddWorkflowMenuOpen = true"
                  (menuClosed)="isAddWorkflowMenuOpen = false">
                  <app-icon
                    class="caret-icon"
                    [iconColor]="EColorPalette.cGray11"
                    [iconHeight]="16"
                    [iconWidth]="16"
                    [svg]="isAddWorkflowMenuOpen ? EIcon.CARET_UP : EIcon.CARET_DOWN"></app-icon>
                </span>
              </span>
            </div>
            <app-fade-text
              class="workflow-setup-description"
              [text]="'These PropUp ticket/Work Order fields would be set automatically'"
              [customStyles]="{
                fontSize: '14px',
                color: EColorPalette.cGray7,
                whiteSpace: 'nowrap'
              }"></app-fade-text>
            <div class="workflow-setup-fields">
              <div
                class="mobile-field-row mobile-field-button"
                *ngFor="let option of workflowFieldOptions"
                [class.is-selected]="selectedWorkflowFieldKey === option.type"
                (click)="toggleWorkflowFieldType(option.type)">
                <div class="mobile-field-row-left">
                  <app-icon
                    [svg]="option.icon"
                    [iconWidth]="24"
                    [iconHeight]="24"
                    [iconColor]="EColorPalette.cOrange2"></app-icon>
                  <span class="mobile-field-row-title">{{ option.label }}</span>
                </div>
                <div class="mobile-field-row-right">
                  <span class="mobile-field-row-value">{{ option.previewValue }}</span>
                  <app-icon
                    *ngIf="option.type !== InspectionTemplateServiceTaskOptionTypes.EstimatedCost"
                    [svg]="EIcon.ANGLE_RIGHT"
                    [iconWidth]="10"
                    [iconHeight]="10"
                    [iconColor]="EColorPalette.cGray5"></app-icon>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </div>

      <mat-menu #addFieldMenu="matMenu" class="menu-with-backdrop" xPosition="before">
        <button
          mat-menu-item
          *ngFor="let option of fieldOptions"
          [disabled]="selectedFieldTypes.includes(option.type)"
          (click)="addFieldOption(option.type)">
          <span class="w-100 display-flex align-items-center justify-content-space-between grid-gap-24">
            <span>{{ option.label }}</span>
            <app-icon
              [svg]="option.icon"
              [iconWidth]="18"
              [iconHeight]="18"
              [iconColor]="EColorPalette.cOrange2"></app-icon>
          </span>
        </button>
      </mat-menu>

      <mat-menu #addWorkflowMenu="matMenu" class="menu-with-backdrop" xPosition="before">
        <button
          mat-menu-item
          *ngFor="let option of fieldOptions"
          [disabled]="workflowFieldTypes.includes(option.type)"
          (click)="addWorkflowFieldOption(option.type)">
          <span class="w-100 display-flex align-items-center justify-content-space-between grid-gap-24">
            <span>{{ option.label }}</span>
            <app-icon
              [svg]="option.icon"
              [iconWidth]="18"
              [iconHeight]="18"
              [iconColor]="EColorPalette.cOrange2"></app-icon>
          </span>
        </button>
      </mat-menu>

      <mat-menu #fieldDefinitionMenu="matMenu" class="menu-with-backdrop" xPosition="before">
        <button mat-menu-item *ngFor="let option of fieldDefinitionOptions" (click)="setFieldDefinition(option)">
          <span class="w-100 display-flex align-items-center justify-content-space-between grid-gap-24">
            <span>{{ option }}</span>
          </span>
        </button>
      </mat-menu>

      <div class="config-panel-right">
        <div class="panel-header panel-header-right">
          <app-fade-text
            class="right-panel-header"
            [text]="getSelectedFieldLabel() ?? 'Field settings'"
            [customStyles]="{
              fontSize: '16px',
              lineHeight: '28px',
              fontWeight: '700',
              letterSpacing: '0',
              whiteSpace: 'nowrap'
            }"></app-fade-text>

          <app-icon
            *ngIf="selectedMobileFieldType !== null || selectedWorkflowFieldKey !== null"
            class="display-flex align-items-center justify-content-center action-button"
            [svg]="EIcon.BB_TRASH"
            [iconWidth]="16"
            [iconHeight]="16"
            [iconColor]="EColorPalette.cGray5"
            (click)="deleteSetting()"></app-icon>
        </div>

        <div class="config-content">
          <div
            *ngIf="isContentLoading"
            class="loading-container display-flex align-items-center justify-content-center">
            <mat-spinner diameter="40"></mat-spinner>
          </div>

          <div
            *ngIf="!isContentLoading && selectedMobileFieldType === null && selectedWorkflowFieldKey === null"
            class="options-forms options-forms-empty">
            <span>
              Select a field on
              <span class="italic">Mobile Inspection App Preview</span>
              or from
              <span class="italic">Workflow Settings</span>
            </span>
          </div>

          <div
            *ngIf="
              !isContentLoading &&
              (selectedMobileFieldType !== null || selectedWorkflowFieldKey !== null) &&
              !isFileAsTypeSelected
            "
            class="options-forms options-forms-selected">
            <span>Field defined by:</span>
            <span class="menu-trigger menu-trigger-words" [class.disabled]="!hasFieldDefinitionOptions">
              <ng-container *ngFor="let word of getMenuTriggerWords(selectedFieldDefinition); let last = last">
                <span
                  class="menu-trigger-word"
                  [matMenuTriggerFor]="hasFieldDefinitionOptions ? fieldDefinitionMenu : null">
                  {{ word }}
                  <span *ngIf="!last"></span>
                </span>
              </ng-container>
              <span
                *ngIf="hasFieldDefinitionOptions"
                class="menu-trigger-word"
                [matMenuTriggerFor]="fieldDefinitionMenu">
                <app-icon
                  class="caret-icon"
                  [iconColor]="EColorPalette.cGray11"
                  [iconHeight]="16"
                  [iconWidth]="16"
                  [svg]="EIcon.CARET_DOWN"></app-icon>
              </span>
            </span>
          </div>

          <ng-container *ngIf="!isContentLoading && isFileAsTypeSelected">
            <form class="file-as-type-form" [formGroup]="fileAsTypeForm">
              <div class="option-form">
                <div class="file-as-type-row">
                  <span class="file-as-type-label">Preselected Submit as:</span>
                  <span
                    class="menu-trigger-inline menu-trigger-inline-small"
                    [matMenuTriggerFor]="submitAsMenu"
                    (menuOpened)="submitAsMenuOpen = true"
                    (menuClosed)="submitAsMenuOpen = false">
                    {{ getSubmitAsLabel(submitAsValue) }}
                    <mat-icon
                      class="simple-icon"
                      [svgIcon]="submitAsMenuOpen ? EIcon.CARET_UP : EIcon.CARET_DOWN"></mat-icon>
                  </span>
                  <span
                    class="menu-trigger-inline menu-trigger-inline-small"
                    [matMenuTriggerFor]="submitAsAvailabilityMenu">
                    {{ getSubmitAsAvailabilityLabel(submitAsValue) }}
                    <mat-icon class="simple-icon" [svgIcon]="EIcon.CARET_DOWN"></mat-icon>
                  </span>
                </div>

                <mat-menu
                  #submitAsMenu="matMenu"
                  class="menu-offset menu-with-backdrop menu-with-backdrop-max-height-10-items">
                  <button mat-menu-item (click)="setSubmitAs(SubmitAsOptions.WorkOrder)">
                    <div class="menu-item-with-check">
                      <span>Work Order</span>
                      <app-icon
                        *ngIf="submitAsValue === SubmitAsOptions.WorkOrder"
                        [iconColor]="EColorPalette.cGreen3"
                        [iconHeight]="24"
                        [iconWidth]="24"
                        [svg]="EIcon.CHECK_YES"></app-icon>
                    </div>
                  </button>
                  <button mat-menu-item (click)="setSubmitAs(SubmitAsOptions.PropUpTicket)">
                    <div class="menu-item-with-check">
                      <span>PropUp Ticket</span>
                      <app-icon
                        *ngIf="submitAsValue === SubmitAsOptions.PropUpTicket"
                        [iconColor]="EColorPalette.cGreen3"
                        [iconHeight]="24"
                        [iconWidth]="24"
                        [svg]="EIcon.CHECK_YES"></app-icon>
                    </div>
                  </button>
                </mat-menu>

                <mat-menu
                  #submitAsAvailabilityMenu="matMenu"
                  class="menu-offset menu-with-backdrop menu-with-backdrop-max-height-10-items">
                  <div class="menu-checkbox-item" (click)="$event.stopPropagation()">
                    <mat-checkbox
                      class="simple-checkbox-no-ripple"
                      color="primary"
                      [checked]="isUserCantChangeSubmitAs()"
                      (click)="$event.stopPropagation()"
                      (change)="setSubmitAsAvailability(!$event.checked)">
                      User can't change
                    </mat-checkbox>
                  </div>
                  <mat-divider></mat-divider>
                  <div class="menu-checkbox-item" (click)="$event.stopPropagation()">
                    <mat-checkbox
                      class="simple-checkbox-no-ripple"
                      color="primary"
                      [checked]="isSubmitAsOptionSelected(SubmitAsOptions.WorkOrder)"
                      [disabled]="isUserCantChangeSubmitAs()"
                      (click)="$event.stopPropagation()"
                      (change)="toggleSubmitAsOption(SubmitAsOptions.WorkOrder, $event.checked)">
                      Work Order
                    </mat-checkbox>
                  </div>
                  <div class="menu-checkbox-item" (click)="$event.stopPropagation()">
                    <mat-checkbox
                      class="simple-checkbox-no-ripple"
                      color="primary"
                      [checked]="isSubmitAsOptionSelected(SubmitAsOptions.PropUpTicket)"
                      [disabled]="isUserCantChangeSubmitAs()"
                      (click)="$event.stopPropagation()"
                      (change)="toggleSubmitAsOption(SubmitAsOptions.PropUpTicket, $event.checked)">
                      PropUp Ticket
                    </mat-checkbox>
                  </div>
                </mat-menu>

                <div *ngIf="showWorkOrderTypeSection" class="file-as-type-section">
                  <div class="file-as-type-row">
                    <span class="file-as-type-label">Preselected Work Order type:</span>
                    <span
                      class="menu-trigger-inline menu-trigger-inline-small"
                      [matMenuTriggerFor]="workOrderTypeMenu"
                      (menuOpened)="workOrderTypeMenuOpen = true"
                      (menuClosed)="workOrderTypeMenuOpen = false">
                      {{ getDefaultDynamicTicketTypeLabel('workOrder') }}
                      <mat-icon
                        class="simple-icon"
                        [svgIcon]="workOrderTypeMenuOpen ? EIcon.CARET_UP : EIcon.CARET_DOWN"></mat-icon>
                    </span>
                  </div>
                  <mat-menu
                    #workOrderTypeMenu="matMenu"
                    class="menu-offset menu-with-backdrop menu-with-backdrop-max-height-10-items">
                    <ng-container *ngFor="let option of workOrderTypeOptions">
                      <button mat-menu-item (click)="setDefaultDynamicTicketType(option.value)">
                        <div class="menu-item-with-check">
                          <span>{{ option.label }}</span>
                          <app-icon
                            *ngIf="fileAsTypeForm.get('defaultDynamicTicketType')?.value === option.value"
                            [iconColor]="EColorPalette.cGreen3"
                            [iconHeight]="24"
                            [iconWidth]="24"
                            [svg]="EIcon.CHECK_YES"></app-icon>
                        </div>
                      </button>
                    </ng-container>
                  </mat-menu>

                  <div class="file-as-type-row">
                    <span
                      class="menu-trigger-inline menu-trigger-inline-small"
                      [matMenuTriggerFor]="workOrderTypeAllowedMenu"
                      [matMenuTriggerRestoreFocus]="false">
                      {{ getAvailableTypeTriggerLabel('workOrder') }}
                      <mat-icon class="simple-icon" [svgIcon]="EIcon.CARET_DOWN"></mat-icon>
                    </span>
                  </div>
                  <mat-menu
                    #workOrderTypeAllowedMenu="matMenu"
                    class="menu-offset menu-with-backdrop menu-with-backdrop-max-height-10-items">
                    <div class="menu-checkbox-item" (click)="$event.stopPropagation()">
                      <mat-checkbox
                        class="simple-checkbox-no-ripple"
                        color="primary"
                        [checked]="isUserCantChangeDynamicTicketTypes('workOrder')"
                        (click)="$event.stopPropagation()"
                        (change)="onUserCantChangeDynamicTicketTypesChange('workOrder', $event.checked)">
                        User can't change
                      </mat-checkbox>
                    </div>
                    <mat-divider></mat-divider>
                    <ng-container *ngFor="let option of workOrderTypeOptions">
                      <div class="menu-checkbox-item" (click)="$event.stopPropagation()">
                        <mat-checkbox
                          class="simple-checkbox-no-ripple"
                          color="primary"
                          [checked]="isAvailableDynamicTicketTypeSelected('workOrder', option.value)"
                          (click)="$event.stopPropagation()"
                          (change)="toggleAvailableDynamicTicketType('workOrder', option.value)">
                          {{ option.label }}
                        </mat-checkbox>
                      </div>
                    </ng-container>
                  </mat-menu>
                </div>

                <div *ngIf="showTicketTypeSection" class="file-as-type-section">
                  <div class="file-as-type-row">
                    <span class="file-as-type-label">Preselected Ticket type:</span>
                    <span
                      class="menu-trigger-inline menu-trigger-inline-small"
                      [matMenuTriggerFor]="ticketTypeMenu"
                      (menuOpened)="ticketTypeMenuOpen = true"
                      (menuClosed)="ticketTypeMenuOpen = false">
                      {{ getDefaultDynamicTicketTypeLabel('ticket') }}
                      <mat-icon
                        class="simple-icon"
                        [svgIcon]="ticketTypeMenuOpen ? EIcon.CARET_UP : EIcon.CARET_DOWN"></mat-icon>
                    </span>
                  </div>
                  <mat-menu
                    #ticketTypeMenu="matMenu"
                    class="menu-offset menu-with-backdrop menu-with-backdrop-max-height-10-items">
                    <ng-container *ngFor="let option of ticketTypeOptions">
                      <button mat-menu-item (click)="setDefaultDynamicTicketType(option.value)">
                        <div class="menu-item-with-check">
                          <span>{{ option.label }}</span>
                          <app-icon
                            *ngIf="fileAsTypeForm.get('defaultDynamicTicketType')?.value === option.value"
                            [iconColor]="EColorPalette.cGreen3"
                            [iconHeight]="24"
                            [iconWidth]="24"
                            [svg]="EIcon.CHECK_YES"></app-icon>
                        </div>
                      </button>
                    </ng-container>
                  </mat-menu>

                  <div class="file-as-type-row">
                    <span
                      class="menu-trigger-inline menu-trigger-inline-small"
                      [matMenuTriggerFor]="ticketTypeAllowedMenu"
                      [matMenuTriggerRestoreFocus]="false">
                      {{ getAvailableTypeTriggerLabel('ticket') }}
                      <mat-icon class="simple-icon" [svgIcon]="EIcon.CARET_DOWN"></mat-icon>
                    </span>
                  </div>
                  <mat-menu
                    #ticketTypeAllowedMenu="matMenu"
                    class="menu-offset menu-with-backdrop menu-with-backdrop-max-height-10-items">
                    <div class="menu-checkbox-item" (click)="$event.stopPropagation()">
                      <mat-checkbox
                        class="simple-checkbox-no-ripple"
                        color="primary"
                        [checked]="isUserCantChangeDynamicTicketTypes('ticket')"
                        (click)="$event.stopPropagation()"
                        (change)="onUserCantChangeDynamicTicketTypesChange('ticket', $event.checked)">
                        User can't change
                      </mat-checkbox>
                    </div>
                    <mat-divider></mat-divider>
                    <ng-container *ngFor="let option of ticketTypeOptions">
                      <div class="menu-checkbox-item" (click)="$event.stopPropagation()">
                        <mat-checkbox
                          class="simple-checkbox-no-ripple"
                          color="primary"
                          [checked]="isAvailableDynamicTicketTypeSelected('ticket', option.value)"
                          (click)="$event.stopPropagation()"
                          (change)="toggleAvailableDynamicTicketType('ticket', option.value)">
                          {{ option.label }}
                        </mat-checkbox>
                      </div>
                    </ng-container>
                  </mat-menu>
                </div>

                <div *ngIf="fileAsTypeOverrideEntries.length" class="file-as-type-overrides">
                  <div
                    *ngFor="let override of fileAsTypeOverrideEntries; trackBy: trackByOverrideKey"
                    class="file-as-type-override">
                    <ng-container *ngIf="!override.isPlaceholder; else missingPmsSettings">
                      <form
                        *ngIf="getOverrideForm(override.key) as overrideForm"
                        [formGroup]="overrideForm"
                        class="file-as-type-override-form">
                        <span class="map-settings-row">
                          <span class="map-settings-label">
                            Work Order type
                            <span class="bold">{{ getDynamicTicketTypeName(override.dynamicTicketTypeId) }}</span>
                            would be submitted in
                            <span class="bold">{{ getPmsProviderName(override.apiCredentialsId) }}</span>
                            with
                            <ng-container *ngIf="hasOverrideDefaultOrigin(override.key); else noDefaultOrigin">
                              origin:
                              <span class="bold">{{ getOverrideDefaultOriginLabel(override.key) }}</span>
                            </ng-container>
                            <ng-template #noDefaultOrigin>no default origin</ng-template>
                            &
                            <ng-container *ngIf="hasOverrideDefaultCategory(override.key); else noDefaultCategory">
                              category:
                              <span class="bold">{{ getOverrideDefaultCategoryLabel(override.key) }}</span>
                            </ng-container>
                            <ng-template #noDefaultCategory>no default category</ng-template>
                          </span>
                        </span>

                        <span class="map-settings-row">
                          <span
                            class="menu-trigger-inline"
                            [matMenuTriggerFor]="allowedOriginsMenu"
                            [matMenuTriggerRestoreFocus]="false">
                            {{ getOverrideSelectionDisplay(override.key, 'allowedOrigins') }}
                            <mat-icon class="simple-icon" [svgIcon]="EIcon.CARET_DOWN"></mat-icon>
                          </span>
                          <mat-menu
                            #allowedOriginsMenu="matMenu"
                            class="menu-offset menu-with-backdrop menu-with-backdrop-max-height-10-items">
                            <div class="menu-checkbox-item" (click)="$event.stopPropagation()">
                              <mat-checkbox
                                class="simple-checkbox-no-ripple"
                                color="primary"
                                [checked]="isUserCantChooseAllowedOrigins(override.key)"
                                (click)="$event.stopPropagation()"
                                (change)="onUserCantChooseAllowedOriginsChange(override.key, $event.checked)">
                                User can't select non default origin
                              </mat-checkbox>
                            </div>
                            <mat-divider></mat-divider>
                            <ng-container *ngFor="let option of getAllowedOriginOptions(override.key)">
                              <div class="menu-checkbox-item" (click)="$event.stopPropagation()">
                                <mat-checkbox
                                  class="simple-checkbox-no-ripple"
                                  color="primary"
                                  [checked]="overrideForm.get('allowedOrigins')?.value?.includes(option.value)"
                                  (click)="$event.stopPropagation()"
                                  (change)="toggleOverrideSelection(override.key, 'allowedOrigins', option.value)">
                                  {{ option.label }}
                                </mat-checkbox>
                              </div>
                            </ng-container>
                          </mat-menu>
                        </span>

                        <span class="map-settings-row">
                          <span
                            class="menu-trigger-inline menu-trigger-inline-small"
                            [matMenuTriggerFor]="allowedCategoriesMenu"
                            [matMenuTriggerRestoreFocus]="false">
                            {{ getOverrideCategorySelectionLabel(override.key) }}
                            <mat-icon class="simple-icon" [svgIcon]="EIcon.CARET_DOWN"></mat-icon>
                          </span>
                          <mat-menu
                            #allowedCategoriesMenu="matMenu"
                            class="menu-offset menu-with-backdrop menu-with-backdrop-max-height-10-items">
                            <div class="menu-checkbox-item" (click)="$event.stopPropagation()">
                              <mat-checkbox
                                class="simple-checkbox-no-ripple simple-checkbox-no-ripple-medium"
                                color="primary"
                                [checked]="isUserCantChooseAllowedCategories(override.key)"
                                (click)="$event.stopPropagation()"
                                (change)="onUserCantChooseAllowedCategoriesChange(override.key, $event.checked)">
                                User can't select non default category
                              </mat-checkbox>
                            </div>
                            <div class="menu-checkbox-item" (click)="$event.stopPropagation()">
                              <mat-checkbox
                                class="simple-checkbox-no-ripple simple-checkbox-no-ripple-medium"
                                color="primary"
                                [checked]="isAllAllowedCategoriesSelected(override.key)"
                                [disabled]="isUserCantChooseAllowedCategories(override.key)"
                                (click)="$event.stopPropagation()"
                                (change)="onSelectAllAllowedCategoriesChange(override.key, $event.checked)">
                                Select All
                              </mat-checkbox>
                            </div>
                            <mat-divider></mat-divider>
                            <ng-container *ngFor="let option of getAllowedCategoryOptions(override.key)">
                              <div class="menu-checkbox-item" (click)="$event.stopPropagation()">
                                <mat-checkbox
                                  class="simple-checkbox-no-ripple simple-checkbox-no-ripple-medium"
                                  color="primary"
                                  [checked]="isAllowedCategorySelected(override.key, option.value)"
                                  [disabled]="isUserCantChooseAllowedCategories(override.key)"
                                  (click)="$event.stopPropagation()"
                                  (change)="toggleAllowedCategorySelection(override.key, option.value)">
                                  {{ option.label }}
                                </mat-checkbox>
                              </div>
                            </ng-container>
                          </mat-menu>
                        </span>
                      </form>
                    </ng-container>
                    <ng-template #missingPmsSettings>
                      <span class="map-settings-row">
                        <span class="map-settings-label">
                          Submit
                          <span class="bold">{{ getDynamicTicketTypeName(override.dynamicTicketTypeId, true) }}</span>
                          to
                          <span class="bold">{{ getPmsDisplayName() }}</span>
                        </span>
                        <span>
                          &nbsp;Not setup yet,
                          <a href="#" (click)="onSetupPmsSettingsForType(override.dynamicTicketTypeId, $event)">
                            click to setup
                          </a>
                        </span>
                      </span>
                    </ng-template>
                  </div>
                </div>

                <mat-checkbox class="simple-checkbox-no-ripple" color="primary" formControlName="fieldRequired">
                  Submission is required
                </mat-checkbox>
                <mat-checkbox
                  class="simple-checkbox-no-ripple"
                  color="primary"
                  [checked]="isOnlyOneWorkOrder"
                  (change)="onOnlyOneWorkOrderChange($event.checked)">
                  Only one work order
                </mat-checkbox>

                <div class="display-flex flex-column grid-gap-8">
                  <div class="file-as-type-row justify-content-space-between">
                    <span class="file-as-type-label">Work order title</span>
                    <mat-checkbox
                      class="simple-checkbox-no-ripple"
                      color="primary"
                      formControlName="autoGeneratedTicketTitle">
                      Auto-generated
                    </mat-checkbox>
                  </div>
                  <app-input
                    class="w-100"
                    [attrPlaceholder]="
                      fileAsTypeForm.get('autoGeneratedTicketTitle')?.value
                        ? autoGeneratedTicketTitlePlaceholder
                        : 'Enter title'
                    "
                    [forcePlaceholder]="fileAsTypeForm.get('autoGeneratedTicketTitle')?.value"
                    [attrDisable]="fileAsTypeForm.get('autoGeneratedTicketTitle')?.value"
                    [containerCss]="'fill body-small'"
                    formControlName="customTicketTitle"></app-input>
                  <mat-checkbox
                    class="simple-checkbox-no-ripple"
                    color="primary"
                    formControlName="userCanEditTicketTitle">
                    User can edit the title
                  </mat-checkbox>
                </div>

                <div class="display-flex flex-column grid-gap-8">
                  <div class="file-as-type-row justify-content-space-between">
                    <span class="file-as-type-label">Description</span>
                    <mat-checkbox
                      class="simple-checkbox-no-ripple"
                      color="primary"
                      formControlName="autoGeneratedTicketDescription">
                      Auto-generated
                    </mat-checkbox>
                  </div>
                  <app-input-area
                    class="w-100"
                    [attrPlaceholder]="
                      fileAsTypeForm.get('autoGeneratedTicketDescription')?.value
                        ? autoGeneratedTicketDescriptionPlaceholder
                        : 'Enter description'
                    "
                    [forcePlaceholder]="fileAsTypeForm.get('autoGeneratedTicketDescription')?.value"
                    [attrDisable]="fileAsTypeForm.get('autoGeneratedTicketDescription')?.value"
                    [containerCss]="'fill body-small'"
                    [inputCss]="'hp-92'"
                    formControlName="customTicketDescription"></app-input-area>
                  <mat-checkbox
                    class="simple-checkbox-no-ripple"
                    color="primary"
                    formControlName="userCanEditTicketDescription">
                    User can edit the description
                  </mat-checkbox>
                </div>
              </div>
            </form>
          </ng-container>
        </div>

        <div class="config-footer">
          <app-button
            [buttonType]="ButtonType.STROKED"
            [buttonColor]="'warn'"
            [buttonLabel]="'Cancel'"
            (clickEvent)="onClose()"></app-button>
          <app-button
            [buttonType]="ButtonType.RAISED"
            [buttonColor]="'primary'"
            [buttonLabel]="'Done'"
            [attrDisabled]="isContentLoading"
            (clickEvent)="onClose(DialogResult.Success)"></app-button>
        </div>
      </div>
    </div>

    <div class="mobile-preview-panel" [class.mobile-preview-panel-hidden]="!showMobilePreview">
      <div class="phone-frame">
        <div class="svg-mobile-frame-container" style="position: absolute; inset: 0">
          <svg viewBox="0 0 390 740" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M311.953 0C332.916 0 351.822 4.92752 365.495 15.9936C379.163 27.0596 387.59 44.2658 387.59 68.8215V234.22H388.013C388.557 234.22 389.058 234.426 389.421 234.765C389.776 235.099 390 235.563 390 236.075V322.139C390 322.651 389.776 323.114 389.421 323.449C389.058 323.783 388.557 323.993 388.013 323.993H387.59V669.481C387.59 697.318 377.742 714.948 363.615 725.619C349.488 736.29 331.093 740 313.988 740H78.6195C57.656 740 38.7502 735.073 25.0823 724.006C11.4093 712.944 2.98273 695.737 2.98273 671.182V323.53H2.5641C2.01381 323.53 1.51753 323.323 1.15967 322.985C0.796745 322.651 0.570551 322.186 0.570551 321.674V269.015C0.570551 268.503 0.796745 268.035 1.15967 267.702C1.51753 267.366 2.01381 267.157 2.5641 267.157H2.98273V252.39H2.5641C2.01381 252.39 1.51753 252.184 1.15967 251.845C0.796745 251.511 0.570551 251.048 0.570551 250.535V197.877C0.570551 197.365 0.796745 196.901 1.15967 196.562C1.51753 196.228 2.01381 196.022 2.5641 196.022H2.98273V170.737H1.98849C1.43988 170.737 0.943603 170.528 0.584055 170.192C0.22113 169.858 0 169.394 0 168.879V144.347C0 143.835 0.22113 143.372 0.584055 143.037C0.943603 142.698 1.43988 142.492 1.98849 142.492H2.98273V70.5222C2.98273 42.6863 12.8306 25.0565 26.9577 14.3841C41.083 3.71335 59.4841 0 76.5837 0H311.953ZM76.2883 16.1258C65.1137 16.1258 49.3054 17.9998 37.4774 26.9336C25.798 35.7588 19.8781 50.45 19.8781 70.6104V671.27C19.8781 689.597 25.3186 703.296 36.0477 711.988C48.3719 721.958 65.8395 724.054 78.3241 724.054H313.693C324.868 724.054 340.676 722.18 352.502 713.243C364.188 704.421 370.103 689.726 370.103 669.569V68.9097C370.103 50.5791 364.663 36.88 353.934 28.1919C341.613 18.2187 324.142 16.1258 311.657 16.1258H76.2883Z"
              fill="#100F0D" />
          </svg>
        </div>

        <div class="mobile-device">
          <div class="mobile-system-top">
            <div class="mobile-notch"></div>
            <div class="mobile-status-bar">
              <span class="time">{{ currentTime | date : 'hh:mm' }}</span>
              <div class="display-flex grid-gap-8">
                <app-icon [svg]="EIcon.SIGNAL" [iconWidth]="18" [iconHeight]="12"></app-icon>
                <app-icon [svg]="EIcon.WIFI" [iconWidth]="17" [iconHeight]="12"></app-icon>
                <app-icon [svg]="EIcon.BATTERY" [iconWidth]="28" [iconHeight]="12"></app-icon>
              </div>
            </div>
          </div>

          <div class="mobile-content-stack">
            <div class="mobile-sheet sheet-back">
              <div class="sheet-back-content">
                <div class="mobile-app-header">
                  <span>Area > Item</span>
                  <button class="close-icon">×</button>
                </div>
                <div class="mobile-content no-scrollbar">
                  <app-cost-file-ticket-parts-setup-placeholder
                    [captureMode]="
                      useFileIcon ? ImageCaptureMode.AnyFile : ImageCaptureMode.PhotoAndGallery
                    "></app-cost-file-ticket-parts-setup-placeholder>
                </div>
              </div>
            </div>
            <div class="mobile-sheet sheet-shadow"></div>

            <div class="mobile-sheet sheet-front">
              <div class="mobile-content-container">
                <div class="mobile-app-header">
                  <span>Create PropUp Ticket</span>
                  <button class="close-icon">×</button>
                </div>
                <div class="mobile-content no-scrollbar">
                  <div class="mobile-form">
                    <app-cost-file-ticket-parts-setup-option
                      *ngFor="let type of mobileFieldTypes"
                      [optionType]="type"
                      [selected]="selectedMobileFieldType === type"
                      (optionSelected)="toggleSelectedFieldType($event)"></app-cost-file-ticket-parts-setup-option>
                    <div
                      class="w-100 display-flex flex-column justify-content-space-between grid-gap-8"
                      [attr.guid]="'guid-comment'">
                      <span class="area-container-label">
                        Add photos
                        <!-- <span class="required">*</span> -->
                      </span>
                      <div
                        class="area-container display-flex align-items-center justify-content-center overflow-hidden">
                        <app-icon
                          [iconHeight]="48"
                          [iconWidth]="48"
                          [svg]="useFileIcon ? EIcon.CLOUD_UPLOAD : EIcon.PHOTO_CAMERA"
                          [iconColor]="EColorPalette.cOrange2"></app-icon>
                      </div>
                    </div>
                    <div
                      class="w-100 display-flex flex-column justify-content-space-between grid-gap-8"
                      [attr.guid]="'guid-comment'">
                      <span class="area-container-label">
                        Add comment
                        <!-- <span class="required">*</span> -->
                      </span>
                      <div class="area-container overflow-hidden">
                        <span>Type your comment here...</span>
                      </div>
                    </div>
                    <div class="mobile-done-button">Done</div>
                  </div>
                </div>

                <div class="home-indicator"></div>
                <div class="home-indicator-gradient"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
